var map = {
	"./en.json": 2450,
	"./fr-CH.json": 2451
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2449;


//////////////////
// WEBPACK FOOTER
// ./i18n/lang ^\.\/.*\.json$
// module id = 2449
// module chunks = 0